"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileCheck, Calculator, TrendingUp, Shield } from "lucide-react";
export default function ServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const services = [{
    id: 1,
    title: "Audit & Assurance",
    description: "Statutory Audits, Internal Audits, and Liquidation Reports",
    icon: FileCheck
  }, {
    id: 2,
    title: "Tax Advisory",
    description: "Corporate Tax compliance (CT), VAT Registration, and Tax Residency Certificates",
    icon: Calculator
  }, {
    id: 3,
    title: "Financial Consulting",
    description: "Feasibility studies, Bookkeeping, and Financial Forecasting",
    icon: TrendingUp
  }, {
    id: 4,
    title: "UAE Regulatory Support",
    description: "ESR (Economic Substance Regulations) and AML (Anti-Money Laundering) compliance",
    icon: Shield
  }];
  return <section className="bg-background py-16 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div ref={ref} className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 group cursor-pointer border border-border shadow-soft transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] translate-y-0 opacity-100 !bg-[hsl(0,0%,98%)] hover:-translate-y-0.5 hover:shadow-medium" style={{
            transitionDelay: isVisible ? `${i * 150}ms` : "0ms"
          }}>
                <CardHeader className="items-center text-center">
                  <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-lg !bg-[hsl(22,78%,26%)]">
                    <Icon className="h-8 w-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-lg font-semibold !text-[hsl(22,78%,26%)]">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <p className="text-sm leading-relaxed !text-[hsl(0,0%,0%)]">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}